/**
 * @generated SignedSource<<64482114778f0d4cb4c5602d9cc716a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraAppType = "CONNECT" | "FORGE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Nav4AppsContent$data = {
  readonly globalAppNavigationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly appId?: string | null;
        readonly appType?: JiraAppType | null;
        readonly id: string;
        readonly label?: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"Nav4ConnectMenuItem" | "Nav4ForgeMenuItem">;
      };
    } | null>;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly " $fragmentType": "Nav4AppsContent";
};
export type Nav4AppsContent$key = {
  readonly " $data"?: Nav4AppsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4AppsContent",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraNavigationItemConnection",
      "kind": "LinkedField",
      "name": "globalAppNavigationItems",
      "plural": false,
      "selections": [
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        },
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraNavigationItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      "action": "THROW"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "label"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "appId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "appType"
                        }
                      ],
                      "type": "JiraAppNavigationItem"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "Nav4ConnectMenuItem"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "Nav4ForgeMenuItem"
                    }
                  ]
                },
                "action": "THROW"
              }
            ]
          },
          "action": "THROW"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "e4a5ba59f2823f40da9513d3a41d72df";

export default node;
